var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valore)?_c('div',{staticClass:"msp-valore"},[(_vm.label)?_c('span',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}}),_vm._v(": ")]):_vm._e(),_vm._v(_vm._s(_vm.renderValue)+" "),(_vm.suffix)?_c('span',{domProps:{"textContent":_vm._s(_vm.suffix)}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }